import Reveal from "./Reveal";
import { useTranslation } from "react-i18next";

const IMG = "https://images.pexels.com/photos/2440524/pexels-photo-2440524.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Manifesto() {
  const { t } = useTranslation();
  const CHAPTERS = t("manifesto.chapters", { returnObjects: true });

  return (
    <section id="nosotros" data-testid="manifesto-section" className="max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-28">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <Reveal className="lg:col-span-5">
          <div className="img-zoom relative rounded-3xl overflow-hidden glass-card">
            <img src={IMG} alt={t("manifesto.imgAlt")} className="w-full h-[320px] sm:h-[460px] object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#05070A]/80 via-transparent to-transparent pointer-events-none" />
            <div className="absolute bottom-5 left-5 right-5">
              <span className="text-[10px] tracking-[0.28em] text-[#F5CB5C] uppercase">{t("manifesto.imgCaption")}</span>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <div className="text-xs uppercase tracking-[0.28em] text-[#F5CB5C] font-semibold">{t("manifesto.kicker")}</div>
            <h2 className="mt-4 font-display text-white text-2xl sm:text-3xl lg:text-4xl leading-tight">
              {t("manifesto.title1")} <span className="text-gold-gradient">{t("manifesto.titleHighlight")}</span>
            </h2>
          </Reveal>
          <div className="mt-10 space-y-8">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <div data-testid={`manifesto-chapter-${i}`} className="flex gap-5 sm:gap-7 items-start border-l border-[#F5CB5C]/20 pl-5 sm:pl-7">
                  <span className="font-display text-2xl sm:text-3xl text-gold-gradient shrink-0">{c.n}</span>
                  <div>
                    <h3 className="font-display text-white text-lg sm:text-xl">{c.title}</h3>
                    <p className="mt-2 text-sm text-gray-400 leading-relaxed max-w-xl">{c.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
